import React, { useContext  } from 'react';
import '../../styles/StudentComponents/StHeroSection.css';
import dashboardImage from '../../assets/Images/Group 276.webp';
import { AuthContext } from '../../context/authContext';
import { Helmet } from 'react-helmet-async';


const StHeroSection = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;

  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL; // replace with your actual TidyCal link
    try {
      window.open(tidycalUrl, '_blank', 'width=600,height=700');
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };

  
  return (
    <section className="st-hero-container">

<Helmet>
<link
    rel="preload"
    as="image"
    href={dashboardImage}
    type="image/webp"
  />
</Helmet>
     
      <div className="st-hero-text">
        <h1>
          Strawket – Discover your <span className="st-highlight">passion</span>
        </h1>
        <p>
          Find what excites you! Whether it’s coding, music, chess, or dance, Strawket connects you with top instructors who make learning fun and easy.<span className='st-gray'> Learn at your pace, track your progress, and explore new skills that shape your future.
          </span>
        </p>
        <div className="st-hero-buttons">
          
            <a 
            href={`${LOGIN_URL}/login`}  
      className="st-login-btn"
    >
      Login
    </a>
          
          {/* <button onClick={handleClick} className="st-demo-btn2">
     Play Demo Video
    </button> */}
        </div>
      </div>

      <div className="st-hero-images">
        <img src={dashboardImage} alt="Strawket Dashboard Preview" loading='lazy' />
      </div>
    </section>
  );
};

export default StHeroSection;
